import React from "react";
import { ChevronRight } from "lucide-react";

interface BreadcrumbProps {
  data: Array<{
    label: string;
    path?: string;
  }>;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ data = [] }) => {
  return (
    <nav>
      <ol className="flex items-center gap-1.5">
        {data?.map((element, index) =>
          index < data?.length - 1 ? (
            <li>
              <a
                className="inline-flex items-center gap-1.5 text-xs md:text-sm text-gray-500 dark:text-gray-400"
                href={element?.path}
              >
                {element?.label}
                {index < data?.length - 1 && (
                  <ChevronRight className="w-4 h-4" />
                )}
              </a>
            </li>
          ) : (
            <li className="text-xs md:text-sm text-gray-800" x-text="pageName">
              {element?.label}
            </li>
          )
        )}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
